import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { getEmployeePositionTitle } from "@/types/employees/employee-position.types.ts";
import { getEmployeeAvatarUrl } from "@/types/employees/employee.types.ts";
import { Button, FontAwesomeIcon, FullScreenPage, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useHireContext } from "../hire-context";

export function HireFinalStep() {
  const { employee, isPreview, hireJobState, exit } = useHireContext();
  const { renderEmployeeName, renderDate } = useFormatter();
  const { t } = useTranslation();
  const isUnknown = !isPreview && hireJobState === "unknown";
  const isPending = !isPreview && !isUnknown;
  const header = isPreview
    ? "hiring_flow:preview_complete"
    : isUnknown
      ? "hiring_flow:hire_status_unknown"
      : "hiring_flow:hire_queued";
  const caption = isPreview
    ? "hiring_flow:preview_hint"
    : isUnknown
      ? "hiring_flow:hire_status_unknown_hint"
      : "hiring_flow:hire_queued_hint";

  return (
    <FullScreenPage contentSize="lg">
      <Stack direction="horizontal" items="center">
        {employee && (
          <StickerCard
            title={renderEmployeeName(employee)}
            caption={getEmployeePositionTitle(employee)}
            avatar_url={getEmployeeAvatarUrl(employee, "4xl")}
            acronym={renderEmployeeName(employee)}
            contentSlot={
              <Text>{`${t("common:first_date")} – ${employee.date_hired_on ? renderDate(employee.date_hired_on) : ""}`}</Text>
            }
          />
        )}
        <Stack className={employee ? "pl-18" : undefined} gap="lg">
          <Stack items="start" gap="md">
            {isPending && (
              <FontAwesomeIcon
                icon="fa-light fa-spinner"
                className="animate-spin text-2xl text-secondary"
              />
            )}
            <Title size="lg" header={t(header)} caption={t(caption)} />
          </Stack>
          <Stack direction="horizontal" gap="sm">
            <Button size="lg" variant={"primary"} onClick={exit}>
              {t(isPreview ? "common:close" : "hiring_flow:go_to_employees")}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </FullScreenPage>
  );
}
